import { NOTIFY_LEVEL, NOTIFY_STATUS, type NotifyLevel, type NotifyStatus } from "@/app/notify";
import { Pill } from "@/ui";

/** 事件等级、投递状态的胶囊；色调与文案取自 app/notify，列表与详情共用。 */
export function LevelPill({ level }: { level: NotifyLevel }) {
  const m = NOTIFY_LEVEL[level] ?? { tone: "neutral", label: level };
  return <Pill tone={m.tone}>{m.label}</Pill>;
}
export function StatusPill({ status }: { status: NotifyStatus }) {
  const m = NOTIFY_STATUS[status] ?? { tone: "neutral", label: status };
  return <Pill tone={m.tone} data-status={status}>{m.label}</Pill>;
}
